var _rect, _path, _circle, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcTaskBlack24Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_task_black_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M19,3H14.6A3.88,3.88,0,0,0,9.4,3H5A2.006,2.006,0,0,0,3,5V20a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Zm0,17H5V5h5.2a1.945,1.945,0,0,1,3.4,0H19Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(11 6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M16.9,11,15.5,9.6l-5,5L9,13.1,7.6,14.5l2.9,2.9h0Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTaskBlack24Px);
export default __webpack_public_path__ + "static/media/ic_task_black_24px.ae7d8635a0780c3bfba7ad3156514c03.svg";
export { ForwardRef as ReactComponent };